import { Component } from '@angular/core';

@Component({
    selector: 'app-no-signal',
    templateUrl: './no-signal.component.html',
    styleUrls: ['./no-signal.component.scss'],
})
export class NoSignalComponent {}
